import World from "../../assets/images/web.svg";
import Insta from "../../assets/images/instagram.svg";
import linkedIn from "../../assets/images/linkedIn.svg";
import facebook from "../../assets/images/facebook.svg";
import youtube from "../../assets/images/youtube.svg";
import Drop from "../../assets/drop.svg";
import icons from "../../assets/icon.svg";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const {pathname} = useLocation();

  const handleLinkClick = (sectionId) => {
    const section = document.getElementById(sectionId);
    if(section){      
      window.scrollTo({
        top: section.offsetTop - 400,
        behavior: "smooth"
      });
    }
  }

  return (
    <footer className="mb-3 px-8 lg:px-16" style={{background: `${pathname==='/contact-us'? '#FFFFFF' : '#FAF9FA' }`}}>
      <div className="">
        <div className="py-16 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-8">
          <div className="col-span-2 md:col-span-3 xl:col-span-1">
            <Link to="/" className="flex items-center py-2">
              <img
                src={icons}
                className="mr-2"
                alt="Logo"
                width={36}
                height={34}
              />

              <span className="text-2xl font-bold text-[#404653]  ">
                RegTechFlow
              </span>
            </Link>
          </div>

          <div>
            <Link to="/solutions" className="font-poppins text-base font-semibold text-[#1E1E1E] py-2 px-3 hover:text-primary">
              Solutions
            </Link>
            <ul className="mt-4 space-y-2 font-poppins">
              <li>
                <Link
                  to="/solutions/corporate-management#solution"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                  onClick={() => handleLinkClick("solution")}
                >
                  Corporate Management
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/license-management#solution"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                  onClick={() => handleLinkClick("solution")}
                >
                  License Management
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/compliance-assurance#solution"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                  onClick={() => handleLinkClick("solution")}
                >
                  Compliance Assurance
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/consultant-advisors#solution"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                  onClick={() => handleLinkClick("solution")}
                >
                  Consultants & Advisors Solutions
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <Link to='/security' className="font-poppins text-base font-semibold text-[#1E1E1E] py-2 px-3 hover:text-primary">
              Security
            </Link>
            <ul className="mt-4 space-y-2 font-poppins">
              <li>
                <Link
                  to="/security#data-security-encryption"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Data Security and Encryption
                </Link>
              </li>
              <li>
                <Link
                  to="/security#real-time-notification"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Real-time Notifications
                </Link>
              </li>
              <li>
                <Link
                  to="/security#security-audits"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Security Audits
                </Link>
              </li>
              <li>
                <Link
                  to="/security#access-controls"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Access Controls
                </Link>
              </li>
              <li>
                <Link
                  to="/security#authentication"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Authentication
                </Link>
              </li>
              <li>
                <Link
                  to="/security#backup-replication"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Backup and Replication
                </Link>
              </li>
              <li>
                <Link
                  to="/security#hosting"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Cloud Hosting Solutions
                </Link>
              </li>
              <li>
                <Link
                  to="/security#certifications"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Certifications
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <Link to='/about-us' className="font-poppins text-base font-semibold text-[#1E1E1E] py-2 px-3 hover:text-primary">
              About Us
            </Link>
            <ul className="mt-4 space-y-2 font-poppins">
              <li>
                <Link
                  to="/about-us#our-story"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Our Story
                </Link>
              </li>
              <li>
                <Link
                  to="/about-us#core-values"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Our Core Values
                </Link>
              </li>
              <li>
                <Link
                  to="/about-us#team"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Meet The Team
                </Link>
              </li>
              <li>
                <Link
                  to="/careers"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <Link to='contact-us' className="font-poppins text-base font-semibold text-[#1E1E1E] py-2 px-3 hover:text-primary">
              Contact
            </Link>
            <ul className="mt-4 space-y-2 font-poppins">
              <li>
                <Link
                  to="/contact-us#send-message"
                  className="text-[#1E1E1E]/70 text-base font-medium hover:text-[#6200EE] px-2.5 py-1.5 block"
                >
                  Send a Message
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <Link to='blog' className="font-poppins text-base font-semibold text-[#1E1E1E] py-2 px-3 hover:text-primary">
              Blog
            </Link>
          </div>
        </div>

        <div className="mt-8 pt-10 pb-8 flex flex-col gap-8 lg:gap-3 lg:flex-row lg:items-center justify-between text-base">
          <p className="text-base text-[#1E1E1E]/70 font-medium max-sm:order-3">
            © RegTechFlow 2025
          </p>
          <div className="flex max-sm:justify-between space-x-4 md:mt-0 max-sm:order-1">
            <Link
              to="terms-and-condition"
              className="text-[#1E1E1E]/70 font-medium hover:text-[#6200EE]"
            >
              Terms & Conditions
            </Link>
            <Link
              to="/privacy-policy"
              className="text-[#1E1E1E]/70 font-medium hover:text-[#6200EE]"
            >
              Privacy Policy
            </Link>
          </div>
          <div className="flex md:flex-col-reverse lg:flex-row max-sm:justify-between max-sm:flex-row-reverse lg:items-center lg:space-x-4 md:gap-4 lg:gap-4 md:mt-0 max-sm:order-2">
            <div className="flex align-center gap-4 max-lg:mt-4">
              <Link
                to="https://www.linkedin.com/company/regtechflow/"
                className="text-[#1E1E1E]/70 font-medium hover:text-[#6200EE] visited:bg-red-600"
                target='_blank'
              >
                {" "}
                <img src={linkedIn} alt="insta" width={20} height={20} />
              </Link>
              <Link
                to="https://www.facebook.com/share/1E9RNNJx29/"
                className="text-[#1E1E1E]/70 font-medium hover:text-[#6200EE]"
                target='_blank'
              >
                {" "}
                <img src={facebook} alt="world" width={20} height={20} />
              </Link>
              <Link
                to="https://www.instagram.com/regtechflow?igsh=ajliZjB3ZHdjamRw"
                className="text-[#1E1E1E]/70 font-medium hover:text-[#6200EE]"
                target='_blank'
              >
                {" "}
                <img src={Insta} alt="world" width={20} height={20} />
              </Link>
              <Link
                to="https://youtu.be/Uo4vA9u1CNk"
                className="text-[#1E1E1E]/70 font-medium hover:text-[#6200EE] mt-[2px]"
                target='_blank'
              >
                {" "}
                <img src={youtube} alt="youtube" width={20} height={21} />
              </Link>
            </div>
            <button className="text-[#1E1E1E]/70 text-base font-medium border border-[#290064] rounded-full px-4 py-2 flex  gap-2 items-center w-fit ">
              <img src={World} alt="world" width={20} height={20} />
              <p> English </p>

              <img src={Drop} alt="drop" width={16} height={16} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
